/**
 * @module lib/navigation
 *
 * Leave the SPA for another URL. A module of its own so a test can observe the
 * navigation, which jsdom cannot perform.
 *
 * @param {string} url Absolute URL
 */
export function navigateTo(url) {
  window.location.assign(url);
}
